import { scrollIntoViewHoriz } from '../utils/horizontal-scroll.js';

export default function initProductNavigationLegacy() {
  const navSection = document.querySelector('.product-navigation-legacy');
  if (!navSection) return;

  const container = navSection.querySelector('.section__wrapper');
  if (!container) return;

  const links = container.querySelectorAll('.section-item a');

  links.forEach(link => {
    link.addEventListener('click', () => {
      scrollIntoViewHoriz(link.closest('.section-item'), container, 'center');
    });
  });

  const { hash } = window.location;
  if (hash) {
    const active = Array.from(links).find(a => a.getAttribute('href') === hash);
    if (active) scrollIntoViewHoriz(active.closest('.section-item'), container, 'center');
  }

  const factsSection = document.querySelector('.product-header__facts');
  let threshold = window.innerHeight;
  let lastState = false;

  const getHeaderHeight = () => {
    const raw = getComputedStyle(document.documentElement).getPropertyValue('--site-header-height');
    const value = parseFloat(raw);
    return Number.isNaN(value) ? 0 : value;
  };

  const setVisible = (visible) => {
    if (visible === lastState) return;
    navSection.classList.toggle('product-navigation-legacy--visible', visible);
    lastState = visible;
  };

  const evaluateVisibility = () => {
    const current = window.scrollY + getHeaderHeight();
    setVisible(current >= threshold);
  };

  const updateThreshold = () => {
    if (factsSection) {
      const rect = factsSection.getBoundingClientRect();
      threshold = window.scrollY + rect.bottom;
    } else {
      threshold = window.innerHeight;
    }
    evaluateVisibility();
  };

  updateThreshold();

  window.addEventListener('scroll', evaluateVisibility, { passive: true });
  window.addEventListener('resize', updateThreshold);
  window.addEventListener('load', updateThreshold);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateThreshold).catch(() => {});
  }
}
